module.exports = require("npm:vanilla-modal@1.6.4/dist/index.js");